import Section1Img from '../../../assets/images/service-section1.webp';
import Smoking from '../../../assets/images/smoking.svg';
import WeightLoss from '../../../assets/images/weight_loss.svg';
import Stress from '../../../assets/images/stress.svg';
import Sleep from '../../../assets/images/sleep.svg';
import Emotional from '../../../assets/images/emotional.svg';
import Relationship from '../../../assets/images/relationship.svg';
import Habit from '../../../assets/images/habit.svg';
import Comfort from '../../../assets/images/comfort.svg';
import IBS from '../../../assets/images/ibs.svg';
import Phobias from '../../../assets/images/phobias.svg';
import Medical from '../../../assets/images/medical.svg';
import Menopausal from '../../../assets/images/menopausal.svg';
import Cancer from '../../../assets/images/cancer.svg';
import Headaches from '../../../assets/images/headaches.svg';
import Performance from '../../../assets/images/focus.svg';
import WhyChooseNirva from '../../../assets/images/whyChooseNirva.webp';
import section5Bg from '../../../assets/images/service-section5.webp';
import startVideoConsultationBackground from '../../../assets/images/start-video-consultation-bg.webp';
import { CONSULTATION_COPY } from '../../../constants/consultation';

export const HERO_CONTENT = {
  title: 'Clinical Hypnotherapy',
  subtext:
    'Online, confidential, and guided by IAIH-certified practitioners.\n When the mind clears, life transforms in its reflection.',
  sectionLabel: 'Offering the Complete Range of Hypnotherapy Services',
  image: Section1Img,
  imageAlt: 'Clinical hypnotherapy session',
};

export const SERVICE_TAGS = [
  'Smoking Cessation',
  'Weight Management',
  'Stress & Worry',
  'Better Sleep',
  'Emotional Balance',
  'Daily Habits',
  'Relationship Patterns',
  'Comfort Skills',
  'Performance & Focus',
];

export const CLIENT_JOURNEY = [
  { id: 1, titleTop: 'Intake Questionnaire', layout: 'textTop' },
  { id: 2, titleBottom: CONSULTATION_COPY.bookAUpper, layout: 'textBottom' },
  { id: 3, titleTop: 'Book Your\nSession', layout: 'textTop' },
  {
    id: 4,
    titleBottom: 'Fill Out Client Participation Agreement',
    layout: 'textBottom',
  },
  { id: 5, titleTop: 'Session(s)', layout: 'textTop' },
  { id: 6, titleBottom: 'Follow-Up', layout: 'textBottom' },
];

export const CORE_SERVICES_SECTION = {
  title: 'Core Services',
  subtext:
    'Every service includes assessment, a customized hypnotherapy plan, skills you can practice\nbetween sessions (including self-hypnosis), and clear next steps.',
  bottomText:
    'Scope note: Nirva offers hypnotherapy for personal transformation and skills development. Our services are not a substitute for medical or counseling care. We’re happy to coordinate with your licensed healthcare professional.',
  buttonText: CONSULTATION_COPY.start,
};

export const CORE_SERVICES = [
  {
    title: 'Smoking Cessation',
    description:
      'Rewire triggers, strengthen a non-smoker identity, and activate motivation for a clear, sustainable shift.',
    image: Smoking,
    reverse: false,
  },
  {
    title: 'Weight Loss & Mindful Eating',
    description:
      'Reduce cue-driven eating, install mindful patterns, and align choices with long-term goals.',
    image: WeightLoss,
    reverse: true,
  },
  {
    title: 'Stress & Anxiety Reduction',
    description:
      'Calm overactive responses, increase resilience, and build everyday tools for steadiness.',
    image: Stress,
    reverse: false,
  },
  {
    title: 'Better Sleep',
    description:
      'Ease mental overactivity, reinforce healthy sleep routines, and practice wind-down hypnosis.',
    image: Sleep,
    reverse: true,
  },
  {
    title: 'Emotional Balance & Regulation',
    description: 'Build awareness, soothe reactivity, and create space for thoughtful responses.',
    image: Emotional,
    reverse: false,
  },
  {
    title: 'Transforming Relationship Patterns',
    description:
      'Shift repetitive loops, strengthen communication, and cultivate presence and empathy.',
    image: Relationship,
    reverse: true,
  },
  {
    title: 'Habit Change & Daily Patterns',
    description:
      'From nail biting to screen-time routines—replace old loops with supportive, automatic actions.',
    image: Habit,
    reverse: false,
  },
  {
    title: 'Performance & Focus',
    subTitle: '(Work, Test, Creative, Sport)',
    description:
      'Use imagery and hypnotic rehearsal to improve concentration, consistency, and calm under pressure.',
    image: Performance,
    reverse: true,
  },
  {
    title: 'Comfort Skills for Persistent Pain',
    subTitle: '',
    description:
      'Train attention, imagery, and relaxation skills to support comfort and coping alongside your care plan.',
    image: Comfort,
    reverse: false,
  },
  {
    title: 'IBS & Gut–Brain Support',
    subTitle: '',
    description:
      'Reduce stress-linked reactivity and practice mind–body strategies that can be helpful day-to-day.',
    image: IBS,
    reverse: true,
  },
  {
    title: 'Phobias & Specific Fears',
    description:
      'Gentle, stepwise desensitization with hypnotic rehearsal for confidence and freedom.',
    image: Phobias,
    reverse: false,
  },
  {
    title: 'Medical/Dental Procedure Preparation',
    description:
      'Reduce anticipatory worry, rehearse calm responses, and support post-procedure ease.',
    image: Medical,
    reverse: true,
  },
  {
    title: 'Menopausal Hot-Flash Support',
    subTitle: '',
    description:
      'Learn cooling imagery and response training that may improve comfort and frequency.',
    image: Menopausal,
    reverse: false,
  },
  {
    title: 'Cancer-Care Journey Support',
    subTitle: '',
    description: 'Skills for relaxation, steadiness, and focus during demanding phases of care.',
    image: Cancer,
    reverse: true,
  },
  {
    title: 'Headaches & Migraines—Comfort Strategies',
    subTitle: '',
    description:
      'Attention training and relaxation methods that can be beneficial for ease and recovery rhythms.',
    image: Headaches,
    reverse: false,
  },
];

export const SESSION_STRUCTURE = [
  'Clarity & Goal-Mapping — define outcomes and success markers',
  'Hypnotic Induction — focused attention and relaxation to support change',
  'Change Work — methods such as interpersonal hypnotherapy, parts work, ego-strengthening, guided imagery, and suggestion',
  'Skills You Keep — self-hypnosis, micro-habits, and simple daily practices',
  'Progress Review — adjust your plan and celebrate wins',
];

export const WHY_CHOOSE_NIRVA = {
  title: 'Why Choose Nirva',
  image: WhyChooseNirva,
  imageAlt: 'Calm woman with landscape silhouette',
  reasons: [
    'IAIH-Certified Practitioners with advanced hypnotherapy training',
    'Relational & Personalized approach—calm, clear, and client-centered',
    'Convenient & Secure — encrypted video sessions, HIPAA-compliant processes',
    'Teach-to-Keep — we emphasize practical tools you can use for life',
  ],
};

export const FINAL_CTA = {
  backgroundImage: section5Bg,
  title: 'Ready To Begin?',
  subtext: 'Book a complimentary Discovery Call to map your plan.',
  buttonText: CONSULTATION_COPY.start,
};

export const START_VIDEO_CONSULTATION = {
  backgroundImage: startVideoConsultationBackground,
  title: 'Every meaningful change begins with a single connection.',
  subtitle: "We're here to listen, support, and guide you\n— one step at a time.",
  buttonText: CONSULTATION_COPY.start,
};
